import { getPath } from '@/router/common'

const baseUrl = {
  title: '找车开票',
  path: 'MybSupplyManagement'
}

export default [
  {
    path: getPath('PzFindCarList', baseUrl),
    name: 'MybSupplyManagement_PzFindCarList',
    component: () => import(/* webpackChunkName: "MybSupplyManagement_PzFindCarList" */ '@/views/mybSupplyManagement/pzFindCarList/index.vue'),
    meta: {
      title: '支付运费'
    }
  },
  {
    path: getPath('CarInfo', baseUrl),
    name: 'MybSupplyManagement_CarInfo',
    component: () => import(/* webpackChunkName: "MybSupplyManagement_CarInfo" */ '@/views/mybSupplyManagement/carInfo/index.vue'),
    meta: {
      title: '满运宝协议'
    }
  },
  {
    path: getPath('TrackQuery', baseUrl),
    name: 'MybSupplyManagement_TrackQuery',
    component: () => import(/* webpackChunkName: "MybSupplyManagement_TrackQuery" */ '@/views/mybSupplyManagement/trackQuery/index.vue'),
    meta: {
      title: '轨迹查询'
    }
  },
  {
    path: getPath('TransportationTrack', baseUrl),
    name: 'MybSupplyManagement_TransportationTrack',
    component: () => import(/* webpackChunkName: "MybSupplyManagement_TransportationTrack" */ '@/views/mybSupplyManagement/transportationTrack/index.vue'),
    meta: {
      title: '运输轨迹'
    }
  },
  {
    path: getPath('pzDialog', baseUrl),
    name: 'MybSupplyManagement_pzDialog',
    component: () => import(/* webpackChunkName: "MybSupplyManagement_pzDialog" */ '@/views/mybSupplyManagement/pzDialog/index.vue'),
    meta: {
      title: '生成配载'
    }
  },
  {
    path: getPath('HomeIndex', baseUrl),
    name: 'MybSupplyManagement_HomeIndex',
    component: () => import(/* webpackChunkName: "MybSupplyManagement_HomeIndex" */ '@/views/mybSupplyManagement/homeIndex/index.vue'),
    meta: {
      title: '开票管理首页'
    }
  },
]
